<template>
  <div
    id="myChart"
    :style="{ width: '90%', height: '100%', margin: '0 auto' }"
  ></div>
</template>

<script>
export default {
  props: ["lineData"],
  data() {
    return {};
  },
  watch: {
    lineData: {
      handler(newvalue, oldvalue) {
        this.drawLine();
      },
      deep: true,
    },
  },
  methods: {
    drawLine() {
      if (document.getElementById("myChart") == null) {
        return;
      }
      this.$echarts.dispose(document.getElementById("myChart"));
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      myChart.setOption({}, true);
      const colorList = ["#9E87FF", "#73DDFF", "#fe9a8b", "#F56948", "#9E87FF"];
      let option = {
        title: {
          textStyle: {
            fontSize: 12,
            fontWeight: 400,
          },
          left: "center",
          top: "5%",
        },
        legend: {
          icon: "circle",
          top: "5%",
          right: "5%",
          itemWidth: 6,
          itemGap: 20,
          textStyle: {
            color: "#556677",
          },
        },
        grid: {
          top: "50px",
          left: "50px",
          right: "15px",
          bottom: "80px",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            label: {
              show: true,
              backgroundColor: "#fff",
              color: "#556677",
              borderColor: "rgba(0,0,0,0)",
              shadowColor: "rgba(0,0,0,0)",
              shadowOffsetY: 0,
            },
            lineStyle: {
              width: 0,
            },
          },
          backgroundColor: "#fff",
          textStyle: {
            color: "#5c6c7c",
          },
          padding: [10, 10],
          extraCssText: "box-shadow: 1px 0 2px 0 rgba(163,163,163,0.5)",
        },
        xAxis: [
          {
            type: "category",
            data: this.lineData.xData,
            axisLine: {
              lineStyle: {
                color: "#CBCBCB", //x轴颜色
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              color: "#999", //坐标轴字颜色
              margin: 15,
            },
            axisPointer: {
              label: {
                padding: [11, 5, 7],
                backgroundColor: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#fff", // 0% 处的颜色
                    },
                    {
                      offset: 0.9,
                      color: "#fff", // 0% 处的颜色
                    },
                    {
                      offset: 0.9,
                      color: "#33c0cd", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#33c0cd", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
            boundaryGap: false,
          },
        ],
        yAxis: [
          {
            type: "value",
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#CBCBCB", //y轴颜色
              },
            },
            axisLabel: {
              color: "#999",
            },
            splitLine: {
              show: false,
            },
          },
        ],
        // dataZoom: [
        //   {
        //     type: "slider",
        //     show: this.lineData.xData.length >= 15 ? true : false,
        //     startValue: 0, //数据窗口范围的起始数值
        //     endValue: 14,
        //     xAxisIndex: [0],
        //     handleSize: 30,
        //     height: 10, //组件高度
        //     bottom: 5, //右边的距离
        //   },
        // ],
        series: [
          {
            name: "平均指标",
            type: "line",
            data: this.lineData.averageData,
            symbolSize: 1,
            symbol: "circle",
            smooth: true,
            yAxisIndex: 0,
            showSymbol: false,
            lineStyle: {
              width: 5,
              color: {
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "#9effff",
                  },
                  {
                    offset: 1,
                    color: "#9E87FF",
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
              shadowColor: "rgba(158,135,255, 0.3)",
              shadowBlur: 10,
              shadowOffsetY: 20,
            },
            itemStyle: {
              color: colorList[0],
              borderColor: colorList[0],
            },
          },
          {
            name: "我的指标",
            type: "line",
            data: this.lineData.myData,
            symbolSize: 1,
            symbol: "circle",
            smooth: true,
            yAxisIndex: 0,
            showSymbol: false,
            lineStyle: {
              width: 5,
              color: {
                x: 1,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "#73DD39",
                  },
                  {
                    offset: 1,
                    color: "#73DDFF",
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
              shadowColor: "rgba(115,221,255, 0.3)",
              shadowBlur: 10,
              shadowOffsetY: 20,
            },
            itemStyle: {
              color: colorList[1],
              borderColor: colorList[1],
            },
          },
        ],
      };
      myChart.setOption(option, true);
      setTimeout(() => {
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      }, 20);
    },
  },
  mounted() {
    this.drawLine();
  },
};
</script>

<style>
</style>